import React, { useRef } from 'react';
import { Button } from "@heroui/react";
import { UploadSimple, X } from '@phosphor-icons/react';

interface UploadProps {
    label?: string;
    onChange: (files: File[]) => void;
    maxCount?: number;
    error?: string;
}

export const Upload: React.FC<UploadProps> = ({
    label,
    onChange,
    maxCount = 1,
    error
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedFiles, setSelectedFiles] = React.useState<File[]>([]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.target.files || []);
        if (files.length > 0) {
            const newFiles = [...selectedFiles, ...files].slice(0, maxCount);
            setSelectedFiles(newFiles);
            onChange(newFiles);
        }
    };

    const handleRemoveFile = (index: number) => {
        const newFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(newFiles);
        onChange(newFiles);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className="space-y-2">
            {label && (
                <label className="block text-sm font-medium mb-1">
                    {label}
                </label>
            )}
            <div className="space-y-2">
                <Button
                    color="default"
                    variant="bordered"
                    startContent={<UploadSimple size={20} />}
                    onClick={() => fileInputRef.current?.click()}
                >
                    Bestand kiezen
                </Button>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className="hidden"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                />
                {selectedFiles.length > 0 && (
                    <div className="space-y-2">
                        {selectedFiles.map((file, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-between p-2 border rounded-lg"
                            >
                                <span className="text-sm truncate">
                                    {file.name}
                                </span>
                                <button
                                    onClick={() => handleRemoveFile(index)}
                                    className="text-danger hover:text-danger-400"
                                >
                                    <X size={20} />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
                {error && (
                    <p className="text-danger text-sm">
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
}; 